import { ref, computed, isRef } from "vue";

export function useServerSort(defaultColumn) {
  const defaultColumnRef = isRef(defaultColumn) ? defaultColumn : ref(defaultColumn);
  const sortColumn = ref(null);
  const sortDirection = ref("desc");

  const effectiveSortColumn = computed(() => sortColumn.value || defaultColumnRef.value);

  const order = computed(() => {
    const prefix = sortDirection.value === "asc" ? "" : "-";
    return `${prefix}${effectiveSortColumn.value}`;
  });

  function handleSort(column) {
    if (effectiveSortColumn.value === column.field) {
      sortDirection.value = sortDirection.value === "asc" ? "desc" : "asc";
    } else {
      sortColumn.value = column.field;
      sortDirection.value = "desc";
    }
  }

  function resetSort() {
    sortColumn.value = null;
    sortDirection.value = "desc";
  }

  return { effectiveSortColumn, sortDirection, order, handleSort, resetSort };
}
